/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_FinishInputs */

const bn_action_finish = /** @type {(inputs: Action_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`শেষ করুন`)
};

const de_action_finish = /** @type {(inputs: Action_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beenden`)
};

const el_action_finish = /** @type {(inputs: Action_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Φινίρισμα`)
};

const en_action_finish = /** @type {(inputs: Action_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finish`)
};

const es_action_finish = /** @type {(inputs: Action_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalizar`)
};

const fr_action_finish = /** @type {(inputs: Action_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminer`)
};

const hi_action_finish = /** @type {(inputs: Action_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खत्म करना`)
};

const hu_action_finish = /** @type {(inputs: Action_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Befejezés`)
};

const id_action_finish = /** @type {(inputs: Action_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyelesaikan`)
};

const it_action_finish = /** @type {(inputs: Action_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fine`)
};

const ja_action_finish = /** @type {(inputs: Action_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仕上げる`)
};

const ko_action_finish = /** @type {(inputs: Action_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`마치다`)
};

const nl_action_finish = /** @type {(inputs: Action_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finish`)
};

const pl_action_finish = /** @type {(inputs: Action_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skończyć`)
};

const pt_action_finish = /** @type {(inputs: Action_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminar`)
};

const ru_action_finish = /** @type {(inputs: Action_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заканчивать`)
};

const sv_action_finish = /** @type {(inputs: Action_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avsluta`)
};

const tr_action_finish = /** @type {(inputs: Action_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sona ermek`)
};

const uk_action_finish = /** @type {(inputs: Action_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закінчити`)
};

const vi_action_finish = /** @type {(inputs: Action_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoàn thành`)
};

const zh_action_finish = /** @type {(inputs: Action_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结束`)
};

const zh_hant_action_finish = /** @type {(inputs: Action_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結束`)
};

/**
* | output |
* | --- |
* | "Finish" |
*
* @param {Action_FinishInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const action_finish = /** @type {((inputs?: Action_FinishInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_FinishInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_action_finish(inputs)
	if (locale === "de") return de_action_finish(inputs)
	if (locale === "el") return el_action_finish(inputs)
	if (locale === "en") return en_action_finish(inputs)
	if (locale === "es") return es_action_finish(inputs)
	if (locale === "fr") return fr_action_finish(inputs)
	if (locale === "hi") return hi_action_finish(inputs)
	if (locale === "hu") return hu_action_finish(inputs)
	if (locale === "id") return id_action_finish(inputs)
	if (locale === "it") return it_action_finish(inputs)
	if (locale === "ja") return ja_action_finish(inputs)
	if (locale === "ko") return ko_action_finish(inputs)
	if (locale === "nl") return nl_action_finish(inputs)
	if (locale === "pl") return pl_action_finish(inputs)
	if (locale === "pt") return pt_action_finish(inputs)
	if (locale === "ru") return ru_action_finish(inputs)
	if (locale === "sv") return sv_action_finish(inputs)
	if (locale === "tr") return tr_action_finish(inputs)
	if (locale === "uk") return uk_action_finish(inputs)
	if (locale === "vi") return vi_action_finish(inputs)
	if (locale === "zh") return zh_action_finish(inputs)
	return zh_hant_action_finish(inputs)
});